module.exports = __webpack_public_path__ + "img/vol02_cup02_cover03.8a64618f.jpg";